import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import axios from 'axios';

import { useModal } from '../../providers/ModalProvider';
import PrimaryButton from '../Buttons/PrimaryButton/PrimaryButton';

const ContactForm = () => {
  const MAX_MESSAGE_LENGTH = 1000;
  const { t, i18n } = useTranslation();
  const modal = useModal();

  const [errors, setErrors] = useState({});
  const [acceptPrivacyPolicy, setAcceptPrivacyPolicy] = useState(0);
  const [messageLength, setMessageLength] = useState(0);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    const data = new FormData(form);
    data.set('subscribe_to_newsletter', form.elements.subscribe_to_newsletter.checked ? '1' : '0');

    setErrors({});

    axios({
      method: 'post',
      url: '/v1/contact-us',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(function (response) {
        modal.showSuccess({
          subtitle: t('contact-form.successfully-submitted'),
        });
        form.reset();
        setMessageLength(0);
        setAcceptPrivacyPolicy(false);
      })
      .catch(function (err) {
        setErrors(err?.response?.data?.result?.errors || {});
      });
  };

  return (
    <div className="customer_service" id="contact_form">
      <div className="customer_wrapper container">
        <div className="customer_content">
          <div className="tag_line">
            <h1>{t('contattaci')}</h1>
            <p>{t('siamo_a_tua_completa_disposizione')}</p>
          </div>
          <div className="form_section">
            <form onSubmit={handleSubmit}>
              <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}>
                <label htmlFor="contact_website">Sito web</label>
                <input id="contact_website" name="website" type="text" tabIndex="-1" autoComplete="off" />
              </div>
              <div className="form_control">
                <input type="text" name="name" placeholder={t('contact-form.name-required')} />
                {errors && errors.name ? <div className="error">{errors.name[0]}</div> : null}
              </div>
              <div className="form_control">
                <input type="text" name="surname" placeholder={t('contact-form.surname-required')} />
                {errors && errors.surname ? <div className="error">{errors.surname[0]}</div> : null}
              </div>
              <div className="form_control">
                <input type="text" name="agency" placeholder={t('agency')} />
                {errors && errors.agency ? <div className="error">{errors.agency[0]}</div> : null}
              </div>
              <div className="form_control">
                <input type="text" name="phone_number" placeholder={t('phone_number')} />
                {errors && errors.phone_number ? <div className="error">{errors.phone_number[0]}</div> : null}
              </div>
              <div className="form_control">
                <input type="email" name="email" placeholder={t('common.email_required')} />
                {errors && errors.email ? <div className="error">{errors.email[0]}</div> : null}
              </div>
              <div className="form_control">
                <textarea
                  name="description"
                  rows="10"
                  cols="50"
                  maxLength={MAX_MESSAGE_LENGTH}
                  onChange={(event) => setMessageLength(event.target.value.length)}
                  placeholder={t('common.inserisci_il_tuo')}
                ></textarea>
                <small aria-live="polite">{messageLength}/{MAX_MESSAGE_LENGTH} caratteri</small>
                {errors && errors.description ? <div className="error">{errors.description[0]}</div> : null}
              </div>
              <div className="form_action">
                <div className="checkbox">
                  <input id="subscribe_to_newsletter" name="subscribe_to_newsletter" type="checkbox" className="checkbox-box" />
                  <label htmlFor="subscribe_to_newsletter">{t('contact-form.subscribe-to-newsletter')}</label>
                </div>
              </div>
              <div className="form_action">
                <div className="checkbox">
                  <input
                    checked={acceptPrivacyPolicy}
                    onChange={(e) => {
                      setAcceptPrivacyPolicy(e.target.checked);
                    }}
                    type="checkbox"
                    className="checkbox-box"
                  />
                  <p>
                    <a href="https://www.iubenda.com/privacy-policy/55960526" target="_blank">
                      {t('common.privacy_policy')}
                    </a>
                  </p>
                </div>
                <PrimaryButton disabled={!acceptPrivacyPolicy}>{t('common.invia_messaggio')}</PrimaryButton>
              </div>
              <p style={{ color: 'darkred' }}>
                {acceptPrivacyPolicy === false ? t('Si prega di accettare la privacy') : ''}
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
